"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

$(document).ready(function () {
  $('.add-to-cart-action').click(function () {
    var thisproduct = $(this).closest('div');
    var qty = thisproduct.find('.qty').val();

    if (!qty) {
      qty = 1;
    }

    var addons = [];
    thisproduct.find('.sell-addon input:checked').each(function () {
      var addonqty = $(this).closest('.sell-addon').find('input[type=number]').val();
      addons.push({
        id: $(this).closest('.sell-addon').attr('data-addon-id'),
        qty: addonqty ? addonqty : 1,
        text: $(this).closest('.sell-addon').find('input[type=text]').val()
      });
    });
    thisproduct.find('.sell-addon select.addon-data').each(function () {
      var option_id = $(this).val();

      if (!option_id) {
        return;
      }

      addons.push({
        id: $(this).closest('.sell-addon').attr('data-addon-id'),
        qty: 1,
        option_id: option_id
      });
    });
    var groupaddons = [];
    thisproduct.find('.sell-group-addon input:checked').each(function () {
      groupaddons.push($(this).closest('.sell-group-addon').find('select').val());
    });
    $.getJSON('/cms/sell/cart/cartAdd', {
      sku: $(this).attr('data-sku-id'),
      qty: qty,
      addons: addons,
      groupaddons: groupaddons
    }, function (data) {
      // For update
      cartapp.fetchcart();
      cartapp.dropdown = true;
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

      if (typeof Noty != "undefined") {
        new Noty({
          timeout: 1000,
          theme: 'semanticui',
          type: 'success',
          text: 'Added to cart'
        }).show();
      } else if (typeof Toasted != "undefined") {
        var toasted = new Toasted({
          position: 'top-center',
          duration: 5000,
          fullWidth: true,
          action: {
            text: 'Checkout now',
            onClick: function onClick() {
              window.location = '/checkout';
            }
          }
        });
        toasted.show('Added to cart');
      }

      if (typeof dataLayer !== 'undefined') {
        dataLayer.push(data.dynamicRemarketingData);
      }
    });
  }); // Count Input (Quantity)
  //------------------------------------------------------------------------------

  $(".incr-btn").on("click", function (e) {
    var $button = $(this);
    var oldValue = $button.parent().find('.incr-qty').val();
    $button.parent().find('.incr-btn[data-action="decrease"]').removeClass('inactive');

    if ($button.data('action') == "increase") {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below 1
      if (oldValue > 1) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
        $button.addClass('inactive');
      }
    }

    $button.parent().find('.incr-qty').val(newVal);
    e.preventDefault();
  });
});
var cartapp = new Vue({
  el: "#cartapp",
  data: {
    dropdown: false,
    hasCartItems: false,
    cartSubtotal: 0,
    cartitems: [],
    cartitemCount: 0
  },
  methods: {
    fetchcart: function fetchcart() {
      var _this = this;

      var url = '/cms/sell/cart/getCart';
      axios.get(url).then(function (response) {
        var subtotal = 0;
        var cartitems = [];
        _this.cartitemCount = 0;
        response.data.forEach(function (item) {
          var thissubtotal = item.qty * item.price;
          item.subtotal = thissubtotal.toFixed(2);
          subtotal += thissubtotal;
          _this.cartitemCount += item.qty;
          cartitems.push(item);
        });
        _this.cartSubtotal = subtotal.toFixed(2);
        _this.cartitems = cartitems;
        _this.hasCartItems = _this.cartitemCount > 0;

        var _iterator = _createForOfIteratorHelper(document.getElementsByClassName('sell-mobile-cart')),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var el = _step.value;

            if (_this.hasCartItems) {
              el.style.display = 'block';
            } else {
              el.style.display = 'none!important';
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    removeItem: function removeItem(cartid) {
      var _this2 = this;

      var url = '/cms/sell/cart/cartRemove/id/' + cartid;
      axios.get(url).then(function (response) {
        _this2.fetchcart();
      });
    },
    dropdownToggle: function dropdownToggle() {
      this.dropdown = !this.dropdown;
    }
  },
  created: function created() {
    this.fetchcart(); //setInterval(this.fetchcart, 30000);
  }
});